export default {
  heading: "EdCity Account Activation",
  intro: "Please create a password to activate your newly registered EdCity account {id}.",
  submitBtn: "Submit",
  resetBtn: "Reset",
  closeBtn: "Close",
  completed:
    "Your account has been activated.",
  recordNotFound: "Sorry, the page you requested cannot be found.<br>Please enter the web address again, or try a different link. For assistance, please contact us on <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>.",
  backToHome: "Back to homepage",
  hasActivated: "You have activated the account by visiting this link already.  The link has expired.",
  expired: "The link has expired.",
  userNotFound: "As there is no record of your account in our system, please contact your School Administrator to check for your account.",
};